/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extracting_AudioInputs */



/**
* | output |
* | --- |
* | "Extracting audio..." |
*
* @param {Extracting_AudioInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const extracting_audio = /** @type {((inputs?: Extracting_AudioInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extracting_AudioInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Extraction audio...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Audio wird extrahiert...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Estrazione audio...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Извлечение аудио...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Extrayendo audio...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在提取音频...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("音声を抽出しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो निकाला जा रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Extraindo áudio...")
	return /** @type {LocalizedString} */ ("Extracting audio...")
});